import { FC, FormEvent } from 'react';
import { InlineInputs } from '../../../../../components/inline-inputs/inline-inputs';
import { Label } from '../../../../../components/label/label';
import { Input } from '../../../../../components/input/input';

interface Props {
  value?: string;
  onChange?: (e: string) => void;
  label: string;
  disabled?: boolean;
}

export const RgbInputs: FC<Props> = (props) => {
  const { label, onChange, value, disabled } = props;

  const [r, g, b] = value?.split(',') || [];

  const handleChange = (e: FormEvent<HTMLInputElement>, index: number) => {
    const updated = [r, g, b];
    let value = e.currentTarget.value;
    if (Number(value) > 255) value = '255';
    if (Number(value) < 0) value = '0';
    if (value.length > 3) return;
    updated[index] = value;
    onChange?.(updated.join(','));
  };

  return (
    <>
      <Label>{label}</Label>
      <InlineInputs>
        <Input
          placeholder="R"
          type="number"
          value={r}
          onChange={(e) => handleChange(e, 0)}
          disabled={disabled}
        />
        <Input
          placeholder="G"
          type="number"
          value={g}
          onChange={(e) => handleChange(e, 1)}
          disabled={disabled}
        />
        <Input
          placeholder="B"
          type="number"
          value={b}
          onChange={(e) => handleChange(e, 2)}
          disabled={disabled}
        />
      </InlineInputs>
    </>
  );
};
